const PATH = 'fe.pages.measure.view';

const messages = {
  title: {
    key: `${PATH}.title`,
    defaultValue: '{{ageLevel}} Measurement'
  },
  loading: {
    key: `${PATH}.loading`,
    defaultValue: 'Loading Measurement…'
  }
};

export default messages;
